{
  "AGENT_MGMT": {
    "HEADER": "Agents",
    "HEADER_BTN_TXT": "Add Agent",
    "LOADING": "Fetching Agent List",
    "DESCRIPTION": "An agent is a member of your customer support team who can view and respond to user messages. The list below shows all the agents in your account.",
    "LEARN_MORE": "Learn about user roles",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Administrator",
      "AGENT": "Agent"
    },
    "TABS": {
      "ACTIVE": "Active",
      "DEACTIVATED": "Deactivated"
    },
    "DISCONNECT_PHONE": {
      "BUTTON_TEXT": "Disconnect Phone",
      "API": {
        "SUCCESS_MESSAGE": "Agent phone disconnected successfully",
        "ERROR_MESSAGE": "Could not disconnect agent phone, please try again later"
      }
    },
    "REACTIVATE": {
      "BUTTON_TEXT": "Reactivate",
      "API": {
        "SUCCESS_MESSAGE": "Agent reactivated successfully",
        "ERROR_MESSAGE": "Could not reactivate agent, please try again later"
      },
      "CONFIRM": {
        "TITLE": "Confirm Reactivation",
        "MESSAGE": "Are you sure you want to reactivate ",
        "YES": "Yes, Reactivate ",
        "NO": "No, Cancel "
      }
    },
    "LIST": {
      "404": "There are no agents associated to this account",
      "TITLE": "Manage agents in your team",
      "DESC": "You can add/remove agents to/in your team.",
      "NAME": "Name",
      "EMAIL": "EMAIL",
      "STATUS": "Status",
      "ACTIONS": "Actions",
      "VERIFIED": "Verified",
      "VERIFICATION_PENDING": "Verification Pending",
      "API_ALLOWED": "API access allowed",
      "DEACTIVATED_ON": "Deactivated on",
      "AVAILABLE_CUSTOM_ROLE": "Available custom role permissions"
    },
    "ADD": {
      "TITLE": "Add agent to your team",
      "DESC": "You can add people who will be able to handle support for your inboxes.",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "FORM": {
        "NAME": {
          "LABEL": "Agent Name",
          "PLACEHOLDER": "Please enter a name of the agent"
        },
        "AGENT_TYPE": {
          "LABEL": "Role",
          "PLACEHOLDER": "Please select a role",
          "ERROR": "Role is required"
        },
        "EMAIL": {
          "LABEL": "Email Address",
          "PLACEHOLDER": "Please enter an email address of the agent"
        },
        "SUBMIT": "Add Agent"
      },
      "API": {
        "SUCCESS_MESSAGE": "Agent added successfully",
        "EXIST_MESSAGE": "Agent email already in use, Please try another email address",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Deactivate",
      "API": {
        "SUCCESS_MESSAGE": "Agent deactivated successfully",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      },
      "CONFIRM": {
        "TITLE": "Confirm Deactivation",
        "MESSAGE": "Are you sure you want to deactivate ",
        "DESCRIPTION": "The agent will be immediately logged out, removed from all teams and inboxes, and will no longer be able to access this account.",
        "YES": "Yes, Deactivate ",
        "NO": "No, Keep "
      }
    },
    "EDIT": {
      "TITLE": "Edit agent",
      "FORM": {
        "NAME": {
          "LABEL": "Agent Name",
          "PLACEHOLDER": "Please enter a name of the agent"
        },
        "AGENT_TYPE": {
          "LABEL": "Role",
          "PLACEHOLDER": "Please select a role",
          "ERROR": "Role is required"
        },
        "EMAIL": {
          "LABEL": "Email Address",
          "PLACEHOLDER": "Please enter an email address of the agent"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Availability",
          "PLACEHOLDER": "Please select an availability status",
          "ERROR": "Availability is required"
        },
        "API_ACCESS": {
          "LABEL": "Allow API access",
          "HELP": "API access is off by default. Turning it on lets this agent's personal API key be used, across every account they belong to. Signing in to the dashboard is not affected."
        },
        "SUBMIT": "Edit Agent"
      },
      "BUTTON_TEXT": "Edit",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "API": {
        "SUCCESS_MESSAGE": "Cooperators updated successfully",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Reset Password",
        "ADMIN_SUCCESS_MESSAGE": "An email with reset password instructions has been sent to the agent",
        "SUCCESS_MESSAGE": "Agent password reset successfully",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      }
    },
    "SEARCH": {
      "NO_RESULTS": "No results found."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "None",
      "TITLE": {
        "AGENT": "Select agent",
        "TEAM": "Select team"
      },
      "LIST": {
        "NONE": "None"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "No agents found",
          "TEAM": "No teams found"
        },
        "PLACEHOLDER": {
          "AGENT": "Search agents",
          "TEAM": "Search teams",
          "INPUT": "Search for agents"
        }
      }
    }
  }
}